import lightGalleryLib from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgVideo from 'lightgallery/plugins/video';

export default class LightGallery {
    constructor() {
        window.addEventListener('load', (e) => {
            this.init();
        });
    }


    init() {
        let lightGalleryItems = document.querySelectorAll('[data-lightgallery-item]');
        if (lightGalleryItems.length > 0) {
            let group = [];
            lightGalleryItems.forEach((v, k) => {
                group.push(v.dataset["lightgalleryItem"]);
            });
            group = group.filter((v, i, a) => a.indexOf(v) === i);

            group.forEach((v, k) => {
                lightGalleryLib(document.body, {
                    plugins: [lgThumbnail, lgVideo],
                    selector: `[data-lightgallery-item='${v}']`,
                    speed: 500,
                    thumbnail: true,
                    licenseKey: 'FA9B9C93-FE54438E-BF08D44B-B809610B',
                    mobileSettings: {
                        controls: true,
                        showCloseIcon: true,
                    },
                });
            });
        }
    }
}
